export enum UserRole {
  SystemAdmin = 'system_admin',
  FirmAdmin = 'firm_admin',
  Paralegal = 'paralegal',
  Solicitor = 'solicitor',
}
